import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="min-h-[70vh] flex items-center justify-center bg-sand-50 px-6">
      <div className="text-center max-w-xl">
        <img
          src="https://customer-assets.emergentagent.com/job_tastebuds-hub/artifacts/2vjwnbkm_Tastbuds%20Food%20Network%20Logo.png"
          alt="Tastebuds Food Network"
          className="w-32 h-32 object-contain mx-auto mb-6 opacity-90"
        />
        <div className="font-mono text-[11px] tracking-[0.4em] uppercase text-brand-500 mb-4">Error 404</div>
        <h1 className="font-serif font-black text-6xl md:text-7xl leading-[0.95] text-sand-900">
          Off the menu.
        </h1>
        <p className="mt-6 text-lg font-light text-sand-700">
          This page isn't on the table tonight. Let's get you back to something delicious.
        </p>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
          <Link
            to="/"
            data-testid="notfound-home-link"
            className="bg-sand-900 text-sand-50 px-7 py-4 font-mono text-[11px] font-bold tracking-[0.25em] uppercase hover:bg-brand-500 transition-colors"
          >
            Back to Home
          </Link>
          <Link
            to="/directory"
            className="px-7 py-4 font-mono text-[11px] font-bold tracking-[0.25em] uppercase text-sand-900 border border-sand-900 hover:bg-sand-900 hover:text-sand-50 transition-colors"
          >
            Browse the Directory
          </Link>
        </div>
      </div>
    </div>
  );
}
